export default __webpack_public_path__ + "static/media/bg-7.eade5ed4.jpg";